export default "__VITE_ASSET__CpnQC7To__"